export type TickerItem = {
  time: string;
  text: string;
};

export type QuickEntry = {
  icon: string;
  label: string;
  hint: string;
  href: string;
};

export type CollectionItem = {
  no: string;
  title: string;
  tag: string;
  count: string;
  updated: string;
  desc: string;
  cover: string;
};

export type StreamItem = {
  id: string;
  tag: "实拍" | "直击" | "录制" | "围观";
  time: string;
  title: string;
  excerpt: string;
  cover: string;
};

export type GalleryItem = {
  id: string;
  title: string;
  tag: string;
  meta: string;
  cover: string;
};

export type GuideStep = {
  icon: string;
  title: string;
  desc: string;
};

export type FaqItem = {
  q: string;
  a: string;
};

export const tickerItems: TickerItem[] = [
  { time: "22:10", text: "音乐节第二日现场实拍合集已刷新，新增 18 段直击画面" },
  { time: "20:45", text: "红毯后台直击片段补齐 6 段，按出场顺序重排时间线" },
  { time: "19:20", text: "片场路透录制档完成补档，原档清晰度已校对" },
  { time: "17:50", text: "粉丝见面会围观合辑新增 12 条，合集索引同步更新" },
  { time: "15:30", text: "发布会现场直击时间线已重排，最早现场排在前" },
  { time: "13:05", text: "本周现场完整记录索引已刷新，可直接从首页入口进入" },
];

export const quickEntries: QuickEntry[] = [
  { icon: "ri-flashlight-line", label: "最新直击", hint: "刚更新的现场", href: "#stream" },
  { icon: "ri-stack-line", label: "合集索引", hint: "按主题翻合集", href: "#collections" },
  { icon: "ri-image-2-line", label: "封面墙", hint: "封面驱动浏览", href: "#covers" },
  { icon: "ri-time-line", label: "时间线", hint: "按时间看更新", href: "#stream" },
  { icon: "ri-compass-3-line", label: "浏览指引", hint: "快速找到原档", href: "#guide" },
];

export const featuredCover = {
  tag: "本周主打现场",
  title: "音乐节主舞台直击：从入场到谢幕的完整记录",
  desc: "按时间顺序整理的开场、彩排、正式演出与散场画面，录制片段与实拍原档分开标注，想看完整围观的从这一段进最快。",
  time: "更新于 22:10",
  meta: "实拍 24 段 · 录制 9 段 · 原档已校对",
  cover:
    "https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20scene%20of%20a%20modern%20outdoor%20music%20festival%20main%20stage%20with%20warm%20amber%20spotlights%20and%20crowd%20silhouettes%2C%20cream%20and%20terracotta%20color%20palette%2C%20soft%20cinematic%20daylight%2C%20elegant%20minimal%20composition%2C%20premium%20print%20aesthetic%2C%20subtle%20film%20grain%2C%20high%20detail&width=1600&height=1000&seq=pctg-hero-01&orientation=landscape",
};

export const collections: CollectionItem[] = [
  {
    no: "01",
    title: "红毯入场现场合辑",
    tag: "实拍",
    count: "36 段",
    updated: "20:45 更新",
    desc: "从红毯起点到签名墙，按出场顺序排列的实拍直击记录。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20red%20carpet%20entrance%20with%20soft%20golden%20lighting%2C%20cream%20backdrop%2C%20muted%20terracotta%20tones%2C%20minimal%20elegant%20composition%2C%20magazine%20quality%2C%20high%20detail%2C%20calm%20atmosphere&width=800&height=600&seq=pctg-col-01&orientation=landscape",
  },
  {
    no: "02",
    title: "音乐节现场直击",
    tag: "直击",
    count: "42 段",
    updated: "22:10 更新",
    desc: "主舞台与分舞台的直击片段，含彩排与散场现场记录。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20festival%20stage%20at%20golden%20hour%20with%20warm%20amber%20lights%20and%20crowd%20silhouettes%2C%20cream%20and%20clay%20palette%2C%20minimal%20elegant%20composition%2C%20magazine%20quality%2C%20high%20detail&width=800&height=600&seq=pctg-col-02&orientation=landscape",
  },
  {
    no: "03",
    title: "片场路透录制档",
    tag: "录制",
    count: "28 段",
    updated: "19:20 更新",
    desc: "片场周边与休息区的录制片段，按拍摄日程归档。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20film%20set%20backstage%20corridor%20with%20soft%20window%20light%20and%20wooden%20props%2C%20cream%20and%20taupe%20tones%2C%20minimal%20elegant%20composition%2C%20magazine%20quality%2C%20high%20detail&width=800&height=600&seq=pctg-col-03&orientation=landscape",
  },
  {
    no: "04",
    title: "发布会现场围观",
    tag: "围观",
    count: "19 段",
    updated: "15:30 更新",
    desc: "发布会台前幕后与媒体区的围观记录，附问答环节摘要。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20press%20conference%20podium%20with%20soft%20spotlight%20and%20microphones%2C%20cream%20and%20amber%20tones%2C%20minimal%20elegant%20composition%2C%20magazine%20quality%2C%20high%20detail&width=800&height=600&seq=pctg-col-04&orientation=landscape",
  },
  {
    no: "05",
    title: "见面会与巡场合集",
    tag: "实拍",
    count: "31 段",
    updated: "17:50 更新",
    desc: "粉丝见面会现场的巡场实拍，含互动环节完整记录。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20cozy%20fan%20meeting%20hall%20with%20warm%20string%20lights%20and%20soft%20cream%20walls%2C%20terracotta%20tones%2C%20minimal%20elegant%20composition%2C%20magazine%20quality%2C%20high%20detail&width=800&height=600&seq=pctg-col-05&orientation=landscape",
  },
];

export const streamItems: StreamItem[] = [
  {
    id: "s1",
    tag: "直击",
    time: "今天 22:10",
    title: "主舞台谢幕现场直击补档",
    excerpt: "散场灯光与人流实拍共 9 段，按时间顺序排在合集最前。",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20editorial%20photo%20of%20a%20warm%20spotlight%20beam%20over%20an%20empty%20stage%2C%20cream%20and%20amber%20tones%2C%20minimal%20composition%2C%20magazine%20quality%2C%20high%20detail&width=400&height=300&seq=pctg-stream-01&orientation=landscape",
  },
  {
    id: "s2",
    tag: "实拍",
    time: "今天 20:45",
    title: "红毯后台实拍片段补齐",
    excerpt: "补上签名墙与候场区的 6 段实拍，顺序已重新校对。",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20editorial%20photo%20of%20a%20warm%20backstage%20corridor%20with%20glowing%20ceiling%20lights%2C%20cream%20and%20terracotta%20tones%2C%20minimal%20composition%2C%20magazine%20quality%2C%20high%20detail&width=400&height=300&seq=pctg-stream-02&orientation=landscape",
  },
  {
    id: "s3",
    tag: "录制",
    time: "今天 19:20",
    title: "片场休息区录制档更新",
    excerpt: "本次录制片段标明了拍摄日程，方便按天翻找完整记录。",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20editorial%20photo%20of%20a%20wooden%20podium%20with%20a%20microphone%20under%20soft%20warm%20light%2C%20cream%20and%20amber%20tones%2C%20minimal%20composition%2C%20magazine%20quality%2C%20high%20detail&width=400&height=300&seq=pctg-stream-03&orientation=landscape",
  },
  {
    id: "s4",
    tag: "围观",
    time: "今天 17:50",
    title: "见面会巡场围观新增 12 条",
    excerpt: "互动环节的围观记录已并入合集索引，可直接从入口进入。",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20editorial%20photo%20of%20neatly%20lined%20up%20chairs%20at%20a%20warm%20venue%20hall%2C%20cream%20and%20clay%20tones%2C%20minimal%20composition%2C%20magazine%20quality%2C%20high%20detail&width=400&height=300&seq=pctg-stream-04&orientation=landscape",
  },
  {
    id: "s5",
    tag: "直击",
    time: "今天 15:30",
    title: "发布会问答现场直击重排",
    excerpt: "按提问顺序重排了时间线，最早现场排在时间线最上方。",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20editorial%20photo%20of%20warm%20hanging%20festoon%20lights%20at%20an%20outdoor%20evening%20event%2C%20cream%20and%20amber%20tones%2C%20minimal%20composition%2C%20magazine%20quality%2C%20high%20detail&width=400&height=300&seq=pctg-stream-05&orientation=landscape",
  },
  {
    id: "s6",
    tag: "实拍",
    time: "昨天 23:15",
    title: "午后彩排实拍整理完成",
    excerpt: "彩排阶段的实拍已单独成一节，和正式演出区分展示。",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20editorial%20photo%20of%20an%20open%20air%20venue%20aisle%20at%20dusk%20with%20warm%20amber%20sky%2C%20cream%20tones%2C%20minimal%20composition%2C%20magazine%20quality%2C%20high%20detail&width=400&height=300&seq=pctg-stream-06&orientation=landscape",
  },
  {
    id: "s7",
    tag: "录制",
    time: "昨天 21:00",
    title: "入场通道录制原档补全",
    excerpt: "补上入场通道的录制片段，原档清晰度已逐段校对。",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20editorial%20photo%20of%20a%20quiet%20studio%20corner%20with%20soft%20natural%20daylight%20and%20wooden%20floor%2C%20cream%20and%20clay%20tones%2C%20minimal%20composition%2C%20magazine%20quality%2C%20high%20detail&width=400&height=300&seq=pctg-stream-07&orientation=landscape",
  },
];

export const galleryItems: GalleryItem[] = [
  {
    id: "g1",
    title: "主舞台侧翼的暖光",
    tag: "直击",
    meta: "实拍 · 12 段",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20editorial%20cover%20photo%20of%20a%20stage%20side%20wing%20with%20warm%20amber%20glow%20and%20drapes%2C%20cream%20background%2C%20muted%20terracotta%20tones%2C%20minimal%20magazine%20composition%2C%20high%20detail%2C%20soft%20film%20grain&width=600&height=800&seq=pctg-gal-01&orientation=portrait",
  },
  {
    id: "g2",
    title: "后台化妆镜前的灯",
    tag: "录制",
    meta: "录制 · 8 段",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20editorial%20cover%20photo%20of%20a%20backstage%20vanity%20mirror%20with%20warm%20bulb%20lights%2C%20cream%20and%20taupe%20tones%2C%20minimal%20magazine%20composition%2C%20high%20detail%2C%20soft%20film%20grain&width=600&height=800&seq=pctg-gal-02&orientation=portrait",
  },
  {
    id: "g3",
    title: "露天场地的黄昏通道",
    tag: "实拍",
    meta: "实拍 · 15 段",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20editorial%20cover%20photo%20of%20an%20open%20air%20venue%20aisle%20at%20dusk%20with%20warm%20amber%20sky%2C%20cream%20tones%2C%20minimal%20magazine%20composition%2C%20high%20detail%2C%20soft%20film%20grain&width=600&height=800&seq=pctg-gal-03&orientation=portrait",
  },
  {
    id: "g4",
    title: "安静角落的一束自然光",
    tag: "围观",
    meta: "围观 · 6 段",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20editorial%20cover%20photo%20of%20a%20quiet%20studio%20corner%20with%20soft%20natural%20window%20light%2C%20cream%20and%20clay%20tones%2C%20minimal%20magazine%20composition%2C%20high%20detail%2C%20soft%20film%20grain&width=600&height=800&seq=pctg-gal-04&orientation=portrait",
  },
  {
    id: "g5",
    title: "检票口的串灯",
    tag: "直击",
    meta: "直击 · 11 段",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20editorial%20cover%20photo%20of%20a%20ticket%20gate%20with%20warm%20hanging%20lamps%20and%20wooden%20railing%2C%20cream%20and%20terracotta%20tones%2C%20minimal%20magazine%20composition%2C%20high%20detail&width=600&height=800&seq=pctg-gal-05&orientation=portrait",
  },
  {
    id: "g6",
    title: "屋顶媒体区的落日",
    tag: "实拍",
    meta: "实拍 · 9 段",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20editorial%20cover%20photo%20of%20a%20rooftop%20press%20terrace%20at%20sunset%20with%20warm%20amber%20light%20over%20a%20soft%20city%20skyline%2C%20cream%20tones%2C%20minimal%20magazine%20composition%2C%20high%20detail&width=600&height=800&seq=pctg-gal-06&orientation=portrait",
  },
];

export const guideSteps: GuideStep[] = [
  {
    icon: "ri-door-open-line",
    title: "从首页入口进",
    desc: "首屏入口条已把最新直击、合集索引和时间线排在一起，想直接看现场就点「最新直击」。",
  },
  {
    icon: "ri-stack-line",
    title: "按合集翻现场",
    desc: "合集索引按主题归档，点开合集会看到按时间分类的录制片段与实拍记录。",
  },
  {
    icon: "ri-download-2-line",
    title: "保留原档",
    desc: "每段现场都标注了实拍、直击或录制类型，确认无误后可按原档保留完整记录。",
  },
];

export const faqItems: FaqItem[] = [
  {
    q: "首页能直接看到哪些现场内容？",
    a: "首页把最新现场直击、合集索引和更新时间线集中放在入口区域，从入口进入即可看到按时间分类的实拍与录制片段，不必再去别处翻帖。",
  },
  {
    q: "录制片段和实拍内容是怎么分类的？",
    a: "每段现场都会标注类型与更新时间，录制片段按时间归档在对应合集里，实拍与直击则按出场或日程顺序排列，方便对照查看。",
  },
  {
    q: "想看现场完整记录要怎么找？",
    a: "可以在合集索引里按主题进入，或在时间线中按更新时间筛选，确认所需的现场后即可查看完整记录与原档保留说明。",
  },
  {
    q: "首页的更新条会多久刷新一次？",
    a: "页面顶部的更新条会按当天最新整理的时段滚动展示，涵盖最新现场直击、录制补档与合集索引的变更时间。",
  },
  {
    q: "为什么同一现场会有多个片段？",
    a: "一个现场通常包含入场、进行中与散场等多个阶段，为便于围观把不同阶段的实拍与录制分开呈现，避免一次性堆在一起。",
  },
];